import React, { PropTypes } from 'react';
import SharedTools from '../../lib/SharedTools';
import DataService from '../../lib/DataService';
import { hashHistory } from 'react-router';
import { Select,Button } from 'antd';

const Option = Select.Option;

export default class ClassEvaluationIndexPage extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    let currentSemester = SharedTools.getCurrentSemester();
    this.state = {
      classId: props.params.classId ? props.params.classId : 0,
      semester: props.location.query.semester ? props.location.query.semester : SharedTools.getCurrentSemester(),
      evaluations: [],
      currentSemester,
      semesters: []
    };
    // bind this
  }

  componentDidMount() {
    let data = {
      class_record_id: this.state.classId,
      semester: this.state.semester,
    }
    DataService.getEvaluationInstances(data).then((res) => {
      this.setState({ evaluations: res })
    }).catch((error) => {
      console.log(error);
    })

    // 学期列表
    let semesters = SharedTools.getAllSemesters(this.state.currentSemester, 20201);

    // 设置默认学期为该年份第一个学期
    this.setState({
      semesters
    })
  }

  selectSemester(value) {
    if (value != this.state.semester) {
      this.setState({
        semester: value,
      }, () => {
        this.componentDidMount()
      })
    }
  }

  _selectSemesterBox() {
    return (
      <div className="select-semester-box">
        <Select value={String(this.state.semester)} style={{ width: 145 }} onChange={this.selectSemester.bind(this)}>
          {this.state.semesters.map((semester, index) => <Option value={String(semester.semester)} key={index}>{semester.semesterToString}</Option>)}
        </Select>
      </div>
    )
  }

  toolStudentEvaluate(student, complete_students) {
    let index = complete_students.findIndex(s => s.id == student.id);
    return index >= 0 ? true : false
  }

  getObservationRecord(student, item, is_complete) {
    hashHistory.push(`development/class-evaluation/classes/${this.state.classId}/observations/${item.id}/students/${student.id}?finalEvaluation=${is_complete}&semester=${this.state.semester}`);
  }

  toolClassEvaluate(students, complete_students) {
    const hasUnevaluated = students.some(student=>
      complete_students.findIndex(s => s.id == student.id)<0
    )
    return hasUnevaluated
  }

  getObservationClassRecord(students, item, is_complete) {
    const studentIds = students.map(student => student.id);
    hashHistory.push(`development/class-evaluation/classes/${this.state.classId}/observations/${item.id}/students/${studentIds}?finalEvaluation=${is_complete}&semester=${this.state.semester}`);
  }

  render() {
    return (
      <div className="class-evaluation-index-page archive-content-setting-class-page">
        {this._selectSemesterBox()}
        <div className="page-header"></div>
        {this.state.evaluations.map(item => <div className="container" key={item.id}>
          <div className="container-header">
            <div className="title">{item.title}</div>
            <Button onClick={() => this.getObservationClassRecord(item.students, item, this.toolClassEvaluate(item.students, item.complete_students))}>
              全班评价
          </Button>
          {/* {this.toolClassEvaluate(item.students, item.complete_students) ?  <a>未全部评价</a> : <span className="evaluate-label">已全部评价</span>} */}
            <div className="info">已完成{item.complete_count}/{item.student_count}</div>
          </div>
          <div className="students-list">
            {item.students.map(student => <div className="student-item" key={student.id} onClick={() => this.getObservationRecord(student, item, this.toolStudentEvaluate(student, item.complete_students))}>
              <div className="student-name">{student.full_name}</div>
              {this.toolStudentEvaluate(student, item.complete_students) ? <span className="evaluate-label">已评价</span> : <a>待评价</a>}
            </div>)}
          </div>
        </div>)}
      </div>
    )
  }
} 


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/development/ClassEvaluationIndexPage.jsx